/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * MCQ Assignment Service
 * @file MCQAssignmentService.js
 * @author Satyaki Bose
 */

import Framework, { BaseService } from '@greenville/framework';
import { AET_STORE_EVENTS } from '../common/Constants';
import { transformBerlinResponse } from '../utils/BerlinMCQAdapter';

export default class MCQAssignmentService extends BaseService {
  constructor() {
    super(AET_STORE_EVENTS.MCQ_ASSIGNMENT_REQUESTED, 'mcqAssignmentStatus');
  }

  /**
   * API call for MCQ assignments
   * @param {*} eventName
   * @param {*} eventData
   * @returns {Promise}
   */
  handleEvent(eventName, eventData = {}) {
    const { bookId } = eventData;

    // GET request for all MCQs for the book
    return this.getClient('marin').get(`/aet/books/${bookId}/mcqs`);
  }

  // eslint-disable-next-line class-methods-use-this
  handleResponse(response) {
    const transformedResponse = transformBerlinResponse(response.data);
    Framework.getStoreRegistry()
      .getStore('syllabus')
      .setMCQQuestionsForAssignments(transformedResponse);
    const mcqStore = Framework.getStoreRegistry().getStore('mcqAssignments');
    if (mcqStore) {
      mcqStore.setMCQData(transformedResponse);
    }
  }
}
